import $ from 'jquery'

import header from './header/header'
import footer from './footer/footer'
import rows from './rows/rows'

import update from './lib/update/update'
import layout from './lib/layout/layout'

export default function(o){

  var p = {}

  var set = function(modelId){

    p.overlay.html('LOADING')
    p.overlay.show()

    setTimeout(function(){

      p.modelId = modelId
      p.data = o.model[modelId].getTableData(o)

      if(p.data.length < 1){
        p.overlay.html('NO DATA')
        return
      }

      p.filters = o.store(p.modelId+'TableFilters') || {}
      p.sorters = o.store(p.modelId+'TableSorters') || []

      p.header = header(o,p)
      p.rows = rows(o,p)

      p.update = update(p)
      p.layout = layout(p)

      p.table.empty()
      .append(
        p.header,
        p.rows,
      )

      p.update()

      p.overlay.hide()

    },500)

  }

  p.footer = footer(o,p)

  p.table =
    $('<div>')
    .css({
      position: 'absolute',
      overflowX: 'scroll',
      top: 0,
      left: 0,
      right: 0,
      bottom: '34px',
    })

  p.overlay =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: '34px',
      backgroundColor: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: o.colors.yellow,
    })
    .html('LOADING')
    .hide()

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      top: '34px',
      left: 0,
      right: 0,
      bottom: 0,
    })
    .append(
      p.table,
      p.footer,
      p.overlay,
    )

  div.set = set

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/table.js